import $ from 'jquery';
import gallerySlider from './gallerySlider';
import slick from 'slick-carousel';

export default () => {
  if ($('body[data-backend]').length > 0 && $('.js-media-gallery-filter').length > 0) {
    filterGalleryAjax();
  } else {
    filterGallery();
  }

  function filterGalleryAjax() {
    let alreadyFiltered = false;
    var loadMoreText = '';
    if (!isRtl) {
      loadMoreText = 'Load More';
    } else {
      loadMoreText = 'عرض المزيد';
    }
    let loadMoreTemplateHtml = $('#js-slider-load-more-template').html();
    loadMoreTemplateHtml = loadMoreTemplateHtml.replace(/\[\[loadMore\]\]/g, loadMoreText);
    $('.js-media-gallery-filter-wrapper').after(loadMoreTemplateHtml);

    if (!isRtl) {
      $('.js-load-more-gallery').text('LOADING ...');
    } else {
      $('.js-load-more-gallery').text('جاري التحميل ...');
    }



    $('.js-media-gallery-filter #cohort').on('change', function () {
      galleryFilter();
    });

    $(document).on('click', '.load-more', function () {
      galleryFilter(false);
    });

    $('.js-media-gallery-filter #cohort-year').on('change', function () {
      galleryFilter();
    });

    let time;
    $('.js-media-gallery-filter #cohort-search').on('change paste keyup', function () {
      let value = $(this).val();
      if (time !== null) {
        clearTimeout(time);
      }
      time = setTimeout(function () {
        if (value.length > 3 || alreadyFiltered === true) {
          alreadyFiltered = false;
          galleryFilter();
        }
      }, 500);
    });

    let isRtl = $('html').attr('dir') === 'rtl';
    let apiUrl = '/api/mediaGalleryService/GetItems';
    let itemsPerPage = $('#media-slider-items-per-page');
    let pageNumber = $('#media-slider-page-number');
    let preselectedEventIds = $('#media-slider-media-ids').val();
    let sortExpression = $('#media-slider-sort-expression').val();
    let culture = 'en';
    if (isRtl) {
      culture = 'ar';
    }

    galleryFilter(false);

    function galleryFilter(clearCurrent) {
      if (clearCurrent !== false) {
        clearCurrent = true;
      }

      if (clearCurrent) {
        if ($('.load-more').length > 0) {
          $('.load-more').remove();
        }
        if ($('.js-slider').length > 0) {
          $("[data-slider-media]").each(function () {
            $(this).slick('unslick');
          });
          $('.media-modal').remove();
          $('.js-slider').remove();
        }
        pageNumber.val(0);
      } else {
        if (!isRtl) {
          $('.js-load-more-gallery').text('LOADING ...');
        } else {
          $('.js-load-more-gallery').text('جاري التحميل ...');
        }
      }

      let take = parseInt(itemsPerPage.val());
      let skip = take * parseInt(pageNumber.val());

      let eventId = $('.js-media-gallery-filter #cohort').val();
      let year = $('.js-media-gallery-filter #cohort-year').val();
      let searchText = $('.js-media-gallery-filter #cohort-search').val();
      
      if (searchText.length > 3) {
        alreadyFiltered = true;
      }

      if (eventId != '') {
        $('[data-gallery-id]').hide();
        $('[data-gallery-id="' + eventId + '"]').show();
        $('.js-media-gallery-filter #cohort-year').prop('disabled', 'disabled');
        $('.js-media-gallery-filter #cohort-year').parent().addClass('disabled');
      } else {
        if (year != '') {
          filterGalleryByYear();
          $('.js-media-gallery-filter #cohort-year').prop('disabled', false);
          $('.js-media-gallery-filter #cohort-year').parent().removeClass('disabled');
        } else {
          $('[data-gallery-id]').show();
          $('[data-gallery-year]').show();
          $('.js-media-gallery-filter #cohort-year').prop('disabled', false);
          $('.js-media-gallery-filter #cohort-year').parent().removeClass('disabled');
        }
      }

      $.get(apiUrl, {
        culture,
        searchText,
        year,
        eventId,
        preselectedEventIds,
        sortExpression,
        skip,
        take,
      }).done((data) => {
        if ($('.load-more').length > 0) {
          $('.load-more').remove();
        }
        if  (data.Items.length == 0) {
          $('.js-not-found').show();
          return;
        }
        else {
          $('.js-not-found').hide();
        }

        let htmlToAdd = '';
        data.Items.forEach((mediaGallery) => {
          let mediaGalleryHtml = $('#media-gallery-slider-template').html();
          let imagesHtml = '';
          let count = 0;

          if (!mediaGallery.Description) {
            mediaGallery.Description = "";
          }

          let videoModalHtml = $('#js-slider-video-modal-template').html();
          let videoModalImageHtml = $('#js-slider-video-modal-image-template').html();
          let videoModalImages = '';
          mediaGallery.Images.forEach((image) => {
            var imageHtml = $('#media-gallery-images-template').html();
            if (!image.ImageUrl) {
              image.ImageUrl = "";
            }
            if (!image.ImageTitle) {
              image.ImageTitle = "";
            }
            if (!image.ImageAlternativeText) {
              image.ImageAlternativeText = "";
            }
            if (!image.ImageThumbnailUrl) {
              image.ImageThumbnailUrl = "";
            }

            videoModalImages += videoModalImageHtml
              .replace(/\[\[Url\]\]/g, image.ImageUrl);

            imagesHtml += imageHtml.replace(/\[\[Index\]\]/g, count)
              .replace(/\[\[Title\]\]/g, mediaGallery.EventTitle)
              .replace(/\[\[ImgUrl\]\]/g, image.ImageUrl)
              .replace(/\[\[ImgThumbnail\]\]/g, image.ImageThumbnailUrl)
              .replace(/\[\[ImgAlt\]\]/g, image.ImageAlternativeText);
            count += 1;
          });

          mediaGalleryHtml = mediaGalleryHtml.replace(/\[\[Title\]\]/g, mediaGallery.EventTitle)
            .replace(/\[\[Year\]\]/g, mediaGallery.Year)
            .replace(/\[\[Id\]\]/g, mediaGallery.EventTitle)
            .replace(/\[\[Description\]\]/g, mediaGallery.Description)
            .replace(/\[\[Images\]\]/g, imagesHtml);

          videoModalHtml = videoModalHtml
            .replace(/\[\[Title\]\]/g, mediaGallery.EventTitle)
            .replace(/\[\[Images\]\]/g, videoModalImages);

          mediaGalleryHtml += videoModalHtml;

          htmlToAdd += mediaGalleryHtml;
        });

        $("[data-slider-media]").removeAttr('data-slider-media');
        if ($('.js-slider').length == 0) {
          $('.js-media-gallery-filter-wrapper').after(htmlToAdd);
        } else {
          $('.js-slider').last().after(htmlToAdd);
        }

        gallerySlider();

        let slidersCount = $('.js-slider').length;
        var loadMoreText = '';
        if (!isRtl) {
          loadMoreText = 'Load More';
        } else {
          loadMoreText = 'عرض المزيد';
        }

        if (slidersCount < data.TotalCount) {
          if ($('.load-more').length > 0) {
            $('.load-more').remove();
          }
          let loadMoreTemplateHtml = $('#js-slider-load-more-template').html();
          loadMoreTemplateHtml = loadMoreTemplateHtml.replace(/\[\[loadMore\]\]/g, loadMoreText);
          $('.js-slider').last().after(loadMoreTemplateHtml);
        } else {
          if ($('.load-more').length > 0) {
            $('.load-more').remove();
          }
        }

        let currentPageNumber = parseInt(pageNumber.val());
        currentPageNumber++;
        pageNumber.val(currentPageNumber);
      });

    }
  }

  function filterGallery() {
    $('.js-media-gallery-filter #cohort').on('change', function () {
      var val = $('.js-media-gallery-filter #cohort').val();
      if (val != '') {
        $('[data-gallery-id]').hide();
        $('[data-gallery-id="' + val + '"]').show();

        $('[data-gallery-id="' + val + '"]').find(".js-slick").slick("setPosition");
        $('.js-media-gallery-filter #cohort-year').prop('disabled', 'disabled');
        $('.js-media-gallery-filter #cohort-year').parent().addClass('disabled');
      } else {
        var year = $('.js-media-gallery-filter #cohort-year').val();
        if (year != '') {
          filterGalleryByYear();
          $('.js-media-gallery-filter #cohort-year').prop('disabled', false);
          $('.js-media-gallery-filter #cohort-year').parent().removeClass('disabled');
        } else {
          $('[data-gallery-id]').show();
          $('.js-media-gallery-filter #cohort-year').prop('disabled', false);
          $('.js-media-gallery-filter #cohort-year').parent().removeClass('disabled');
        }
      }
    });
    $('.js-media-gallery-filter #cohort-year').on('change', function () {
      filterGalleryByYear();
    });
  }

  function filterGalleryByYear() {
    var val = $('.js-media-gallery-filter #cohort-year').val();
    if (val != '') {
      $('[data-gallery-year]').hide();
      $('[data-gallery-year="' + val + '"]').show();
    } else {
      $('[data-gallery-year]').show();
    }
  }
}
